export enum CategoryActionTypes {
    API_RESPONSE_SUCCESS = '@@categories/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR = '@@categories/API_RESPONSE_ERROR',

    GET_CATEGORIES = '@@categories/GET_CATEGORIES',
}
